import { render, staticRenderFns } from "./switch2.vue?vue&type=template&id=a5938162&scoped=true&"
import script from "./switch2.vue?vue&type=script&lang=js&"
export * from "./switch2.vue?vue&type=script&lang=js&"
import style0 from "./switch2.vue?vue&type=style&index=0&id=a5938162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5938162",
  null
  
)

export default component.exports